import { Directive, HostListener, Input, Optional, SkipSelf, TemplateRef } from '@angular/core';

import { DropdownComponent } from '../dropdown.component';

@Directive({
  selector: '[targetFor]',
  standalone: true,
})
export class NestedTemplateTriggerDirective {
  @Input('targetFor') public templateRef?: TemplateRef<any>;
  @Input('dropdownComponentRef') public dropdownRef?: DropdownComponent;

  constructor(@Optional() @SkipSelf() private dropdownComponent: DropdownComponent) {}

  // eslint-disable-next-line ban/ban
  @HostListener('click', ['$event'])
  public setTemplate($event: Event): void {
    $event.preventDefault();
    const dropdownCmp = this.dropdownRef || this.dropdownComponent;
    if (!this.templateRef || !dropdownCmp) return;
    dropdownCmp.setNestedTemplate(this.templateRef);
  }
}
